import _regeneratorRuntime from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export function getBytes(_x, _x2) {
  return _getBytes.apply(this, arguments);
}

function _getBytes() {
  _getBytes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, onChunk) {
    var reader, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            reader = stream.getReader();

          case 1:
            _context.next = 3;
            return reader.read();

          case 3:
            if ((result = _context.sent).done) {
              _context.next = 7;
              break;
            }

            onChunk(result.value);
            _context.next = 1;
            break;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getBytes.apply(this, arguments);
}

export function getLines(onLine) {
  var buffer;
  var position;
  var fieldLength;
  var discardTrailingNewline = false;
  return function onChunk(arr) {
    if (buffer === undefined) {
      buffer = arr;
      position = 0;
      fieldLength = -1;
    } else {
      buffer = concat(buffer, arr);
    }

    var bufLength = buffer.length;
    var lineStart = 0;

    while (position < bufLength) {
      if (discardTrailingNewline) {
        if (buffer[position] === 10) {
          lineStart = ++position;
        }

        discardTrailingNewline = false;
      }

      var lineEnd = -1;

      for (; position < bufLength && lineEnd === -1; ++position) {
        switch (buffer[position]) {
          case 58:
            if (fieldLength === -1) {
              fieldLength = position - lineStart;
            }

            break;

          case 13:
            discardTrailingNewline = true;

          case 10:
            lineEnd = position;
            break;
        }
      }

      if (lineEnd === -1) {
        break;
      }

      onLine(buffer.subarray(lineStart, lineEnd), fieldLength);
      lineStart = position;
      fieldLength = -1;
    }

    if (lineStart === bufLength) {
      buffer = undefined;
    } else if (lineStart !== 0) {
      buffer = buffer.subarray(lineStart);
      position -= lineStart;
    }
  };
}
export function getMessages(onId, onRetry, onMessage) {
  var message = newMessage();
  var decoder = new TextDecoder();
  return function onLine(line, fieldLength) {
    if (line.length === 0) {
      onMessage === null || onMessage === void 0 ? void 0 : onMessage(message);
      message = newMessage();
    } else if (fieldLength > 0) {
      var field = decoder.decode(line.subarray(0, fieldLength));
      var valueOffset = fieldLength + (line[fieldLength + 1] === 32 ? 2 : 1);
      var value = decoder.decode(line.subarray(valueOffset));

      switch (field) {
        case 'data':
          message.data = message.data ? message.data + '\n' + value : value;
          break;

        case 'event':
          message.event = value;
          break;

        case 'id':
          onId(message.id = value);
          break;

        case 'retry':
          var retry = parseInt(value, 10);

          if (!isNaN(retry)) {
            onRetry(message.retry = retry);
          }

          break;
      }
    }
  };
}

function concat(a, b) {
  var res = new Uint8Array(a.length + b.length);
  res.set(a);
  res.set(b, a.length);
  return res;
}

function newMessage() {
  return {
    data: '',
    event: '',
    id: '',
    retry: undefined
  };
}